import { chapterDetailsActionTypes } from './Constants';

export function getChapterDetails(chapterId) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS,
		payload: {
			chapterId,
		},
	};
}

export function getChapterDetailsSuccess(chapterDetails) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUCCESS,
		payload: {
			chapterDetails,
		},
	};
}

export function getChapterDetailsError() {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_ERROR,
	};
}

export function getChapterDetailsParagraphs(chapterId) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_PARAGRAPHS,
		payload: {
			chapterId,
		},
	};
}

export function getChapterDetailsParagraphsSuccess(chapterDetailsParagraphs) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_PARAGRAPHS_SUCCESS,
		payload: {
			chapterDetailsParagraphs,
		},
	};
}

export function getChapterDetailsParagraphsError() {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_PARAGRAPHS_ERROR,
	};
}

export function getChapterDetailsSummary(chapterId, videokey) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUMMARY,
		payload: {
			chapterId,
			videokey,
		},
	};
}

export function getChapterDetailsSummarySuccess(chapterDetailsSummary) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUMMARY_SUCCESS,
		payload: {
			chapterDetailsSummary,
		},
	};
}

export function getChapterDetailsSummaryError() {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUMMARY_ERROR,
	};
}

export function getPausedDiagnosticTest(chapterId, isPublic, loadParagraphs, exerciseId) {
	return {
		type: chapterDetailsActionTypes.GET_PAUSED_DIAGNOSTIC_TEST,
		payload: {
			chapterId,
			isPublic,
			loadParagraphs,
			exerciseId,
		},
	};
}

export function getPausedDiagnosticTestSuccess(data) {
	return {
		type: chapterDetailsActionTypes.GET_PAUSED_DIAGNOSTIC_TEST_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getPausedDiagnosticTestError() {
	return {
		type: chapterDetailsActionTypes.GET_PAUSED_DIAGNOSTIC_TEST_ERROR,
	};
}

export function getToDoTopics(exerciseId) {
	return {
		type: chapterDetailsActionTypes.GET_TO_DO_TOPICS,
		payload: {
			exerciseId,
		},
	};
}

export function getToDoTopicsSuccess(toDoTopics) {
	return {
		type: chapterDetailsActionTypes.GET_TO_DO_TOPICS_SUCCESS,
		payload: {
			toDoTopics,
		},
	};
}

export function getToDoTopicsError() {
	return {
		type: chapterDetailsActionTypes.GET_TO_DO_TOPICS_ERROR,
	};
}

export function getRelatedQuestions(data, chapterId) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_RELATED_QUESTIONS,
		payload: {
			data,
			chapterId,
		},
	};
}

export function getRelatedQuestionsSuccess(data) {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_RELATED_QUESTIONS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getRelatedQuestionsError() {
	return {
		type: chapterDetailsActionTypes.GET_CHAPTER_RELATED_QUESTIONS_ERROR,
	};
}

export function clearParagraphsData() {
	return {
		type: chapterDetailsActionTypes.CLEAR_PARAGRAPHS_DATA,
	};
}

export function clearSummaryData() {
	return {
		type: chapterDetailsActionTypes.CLEAR_SUMMARY_DATA,
	};
}

export function clearToDoData() {
	return {
		type: chapterDetailsActionTypes.CLEAR_TODO_DATA,
	};
}

export function cleanChapterDetailsState() {
	return {
		type: chapterDetailsActionTypes.CLEAN_CHAPTER_DETAILS_STATE,
	};
}
